import {TEMPLATE_CATALOG} from "../data/template-catalog";
import {resolveOfferedBannerSelection, type BannerSelection} from "../data/template-availability";

export function selectionKey(selection: BannerSelection): string {
  return JSON.stringify([selection.templateKey, selection.product, selection.contentType, selection.set]);
}
export function availableTemplates({channel, product, contentType, set}: {channel: string; product: string; contentType: string; set?: string | null}) {
  return TEMPLATE_CATALOG.filter((definition) => definition.isCodeDefault && definition.channel === channel && (set === undefined || (definition.set ?? null) === set))
    .flatMap((definition) => {
      const selection: BannerSelection = {templateKey: definition.templateKey, product, contentType, set: definition.set ?? null};
      try {return [{...resolveOfferedBannerSelection(selection), selection}];} catch {return [];}
    });
}
